import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewGroupMutation } from "./groupsApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"

const NewGroupForm = ({ companies }) => {

    const [addNewGroup, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewGroupMutation()
    const {groupId, type} = useParams()
    const navigate = useNavigate()

    const [name, setName] = useState('')
    const [year, setYear] = useState('')
    const [courseName, setCourseName] = useState('')
    const [semester, setSemester] = useState('')
    const [active, setActive] = useState(true)
    const [company, setCompany] = useState(companies[0].id)

    useEffect(() => {
        if (isSuccess) {
            setName('')
            setYear('')
            setCompany('')
            navigate(`/${type}/${groupId}/groups`)
        }
    }, [isSuccess, navigate])





    // const onTitleChanged = e => setTitle(e.target.value)
    // const onTextChanged = e => setText(e.target.value)
    // const onUserIdChanged = e => setUserId(e.target.value)

    const canSave = [name, year, company].every(Boolean) && !isLoading

    const onSaveGroupClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewGroup({ company, name, year , active , semester, courseName})
        }
    }

    const options = companies.map(c => {
        return (
            <option
                key={c.id}
                value={c.id}
            > {c.name}</option >
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"
    const validTitleClass = !name ? "form__input--incomplete" : ''
    const validYearClass = !year ? "form__input--incomplete" : ''
    const validCourseNameClass = !name ? "form__input--incomplete" : ''

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveGroupClicked}>
                <div className="form__title-row">
                    <h2>New Group</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/groups`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="name">
                  שם קורס + מזהה קבוצה ייחודי  [ריאקט ב' פרונט  1 וכד'] </label>
                <input
                    className={`form__input ${validTitleClass}`}
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    value={name}
                    onChange={e=>setName(e.target.value)}
                />
                <label className="form__label" htmlFor="courseName">
                   שם הקורס הנלמד [HTML CSS וכד']:</label>
                <input
                    className={`form__input ${validCourseNameClass}`}
                    id="courseName"
                    name="courseName"
                    type="text"
                    autoComplete="off"
                    value={courseName}
                    onChange={e=>setCourseName(e.target.value)}
                />
               
               <label className="form__label" htmlFor="year">
                    Year: [תשפ"ד וכד']</label>
                <input
                    className={`form__input ${validYearClass}`}
                    id="year"
                    name="year"
                    type="text"
                    autoComplete="off"
                    value={year}
                    onChange={e=>setYear(e.target.value)}
                />

<label className="form__label" htmlFor="semester">
                    Semester: [מחצית א' וכד']</label>
                <input
                    className={`form__input`}
                    id="semester"
                    name="semester"
                    type="text"
                    autoComplete="off"
                    value={semester}
                    onChange={e=>setSemester(e.target.value)}
                />

                <label className="form__label form__checkbox-container" htmlFor="company">
                    COMPANY:</label>
                <select
                    id="company"
                    name="company"
                    className="form__select"
                    value={company}
                    onChange={e=>setCompany(e.target.value)}
                >
                    {options}
                </select>

                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="company-active">
                            ACTIVE:
                            <input
                                className="form__checkbox"
                                id="company-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={e => setActive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>

            </form>
        </>
    )

    return content
}

export default NewGroupForm